var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128037(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-128_037-1{fill:#fff;}.cls-128_037-2,.cls-128_037-3,.cls-128_037-4,.cls-128_037-5{fill:none;}.cls-128_037-2{opacity:0.2;}.cls-128_037-3,.cls-128_037-4{stroke:#6e6e6e;}.cls-128_037-3,.cls-128_037-5{stroke-miterlimit:10;}.cls-128_037-3,.cls-128_037-4,.cls-128_037-5{stroke-width:1.25px;}.cls-128_037-4,.cls-128_037-5{stroke-linecap:round;}.cls-128_037-4{stroke-linejoin:round;}.cls-128_037-5{stroke:#ff6a10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-2",
    y: -0.48,
    width: 128,
    height: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-3",
    d: "M102.41,113c-.42-18.09-6-38.12-32.3-40.89a1.65,1.65,0,0,1-1.46-1.64V57.24a1.65,1.65,0,0,1,1.46-1.64c26.26-2.77,32.52-23,32.3-40.89v-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-3",
    d: "M24.91,14v.67c.34,17,5.71,37.08,30.37,40.64A1.65,1.65,0,0,1,56.68,57v13.7a1.64,1.64,0,0,1-1.4,1.63c-24.66,3.56-31,23.57-30.87,40.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-3",
    d: "M106.33,14H21.67a1.52,1.52,0,0,1-1.52-1.51V7.16a1.52,1.52,0,0,1,1.52-1.52h84.66a1.52,1.52,0,0,1,1.52,1.52v5.37A1.52,1.52,0,0,1,106.33,14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-3",
    x: 20.15,
    y: 113.23,
    width: 87.69,
    height: 7.77,
    rx: 3.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128_037-4",
    cx: 62.52,
    cy: 45.1,
    r: 8.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 62.54,
    y1: 50.88,
    x2: 62.54,
    y2: 52.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 68.33,
    y1: 45.15,
    x2: 69.49,
    y2: 45.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 55.6,
    y1: 45.18,
    x2: 56.77,
    y2: 45.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 62.36,
    y1: 38.15,
    x2: 62.36,
    y2: 39.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-4",
    d: "M65.7,42.81c0,.1-3.17,3.3-3.17,3.3l-2.26-2.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128_037-4",
    cx: 45.57,
    cy: 40.9,
    r: 8.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 47.75,
    y1: 46.26,
    x2: 48.19,
    y2: 47.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 50.97,
    y1: 38.77,
    x2: 52.05,
    y2: 38.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 39.18,
    y1: 43.56,
    x2: 40.26,
    y2: 43.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 42.82,
    y1: 34.52,
    x2: 43.26,
    y2: 35.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-4",
    d: "M47.66,37.59c0,.09-1.71,4.25-1.71,4.25l-3-1.37"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128_037-4",
    cx: 79.73,
    cy: 42.34,
    r: 8.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 80.23,
    y1: 48.11,
    x2: 80.33,
    y2: 49.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 85.52,
    y1: 41.91,
    x2: 86.68,
    y2: 41.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 72.84,
    y1: 43,
    x2: 74,
    y2: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 78.99,
    y1: 35.44,
    x2: 79.09,
    y2: 36.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-4",
    d: "M82.71,39.8c0,.1-2.89,3.56-2.89,3.56l-2.44-2.19"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128_037-4",
    cx: 67.81,
    cy: 27.52,
    r: 8.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 64.72,
    y1: 32.41,
    x2: 64.09,
    y2: 33.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 72.68,
    y1: 30.68,
    x2: 73.67,
    y2: 31.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 61.93,
    y1: 23.87,
    x2: 62.92,
    y2: 24.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-4",
    x1: 71.41,
    y1: 21.57,
    x2: 70.78,
    y2: 22.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-4",
    d: "M71.72,27.3c0,.08-4.45,1.08-4.45,1.08l-.62-3.23"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-128_037-5",
    cx: 62.52,
    cy: 82.48,
    r: 8.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128_037-5",
    d: "M63.7,78.57a3.7,3.7,0,1,0-1.48,7.25A3.65,3.65,0,0,0,65,85.28a3.7,3.7,0,0,0,1.59-2.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 58.5,
    y1: 84.11,
    x2: 62.2,
    y2: 81.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 59.45,
    y1: 85.55,
    x2: 63.15,
    y2: 83.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-5",
    x: 47.73,
    y: 107.87,
    width: 17.48,
    height: 4.26,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 50.46,
    y1: 109.3,
    x2: 50.46,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 54.47,
    y1: 109.3,
    x2: 54.47,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 58.47,
    y1: 109.3,
    x2: 58.47,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 62.48,
    y1: 109.3,
    x2: 62.48,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-5",
    x: 54.45,
    y: 103.22,
    width: 17.48,
    height: 4.26,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 57.18,
    y1: 104.65,
    x2: 57.18,
    y2: 106.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 61.19,
    y1: 104.65,
    x2: 61.19,
    y2: 106.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 65.19,
    y1: 104.65,
    x2: 65.19,
    y2: 106.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 69.2,
    y1: 104.65,
    x2: 69.2,
    y2: 106.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-5",
    x: 63.36,
    y: 98.46,
    width: 17.48,
    height: 4.26,
    rx: 2.13,
    transform: "translate(74.57 -23.14) rotate(36.77)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 67.7,
    y1: 96.44,
    x2: 66.87,
    y2: 97.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 70.91,
    y1: 98.83,
    x2: 70.08,
    y2: 99.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 74.12,
    y1: 101.23,
    x2: 73.28,
    y2: 102.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 77.33,
    y1: 103.63,
    x2: 76.49,
    y2: 104.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-5",
    x: 36.79,
    y: 104.22,
    width: 17.48,
    height: 4.26,
    rx: 2.13,
    transform: "translate(-49.37 40.18) rotate(-31.94)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 40.06,
    y1: 108.94,
    x2: 40.8,
    y2: 110.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 43.46,
    y1: 106.82,
    x2: 44.2,
    y2: 108.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 46.86,
    y1: 104.7,
    x2: 47.6,
    y2: 105.89
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 50.25,
    y1: 102.58,
    x2: 51,
    y2: 103.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128_037-5",
    x: 65.66,
    y: 107.87,
    width: 17.48,
    height: 4.26,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 68.39,
    y1: 109.3,
    x2: 68.39,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 72.4,
    y1: 109.3,
    x2: 72.4,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 76.41,
    y1: 109.3,
    x2: 76.41,
    y2: 110.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-128_037-5",
    x1: 80.41,
    y1: 109.3,
    x2: 80.41,
    y2: 110.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128037);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_037.5ba1c3284168d53ee64c857b9d4ab9e0.svg";
export { ForwardRef as ReactComponent };